import { IApplicationState } from '../../types/redux';

export function selectIsChatModalOpen(state: IApplicationState): boolean {
  return state.chatModal.isOpen;
}
